import {
  GoogleMap,
  Marker,
  Circle,
} from "@react-google-maps/api";
import {
  useEffect,
  useRef,
  useState,
} from "react";

const ReportFence = ({
  center,
  radius,
  markerPosition,
}) => {
  const mapRef = useRef(null);
  const [zoomLevel, setZoomLevel] = useState(10); // Default zoom level

  // Function to calculate zoom level based on radius
  const calculateZoomLevel = (radius) => {
    let zoom;
    if (radius < 10) {
      zoom = 15; // Close zoom for small radius
    } else if (radius >= 10 && radius <= 50) {
      zoom = 13; // Medium zoom
    } else if (radius > 50 && radius <= 100) {
      zoom = 11; // Less zoom
    } else {
      zoom = 10; // Further out for large radius
    }
    return zoom;
  };

  // Update zoom level when radius changes
  useEffect(() => {
    const newZoomLevel = calculateZoomLevel(
      parseFloat(radius)
    );
    setZoomLevel(newZoomLevel);

    if (mapRef.current) {
      // Recenter and apply new zoom level when radius changes
      mapRef.current.setZoom(newZoomLevel);
      mapRef.current.panTo(center);
    }
  }, [radius, center]);
  return (
    <>
      <div className="relative">
        <GoogleMap
          mapContainerStyle={{
            height: "500px",
            width: "100%",
            marginTop: "20px",
          }}
          zoom={zoomLevel}
          center={center}
        >
          <Marker position={markerPosition} />
          <Circle
            center={center}
            radius={parseFloat(radius) * 1000}
            options={{
              strokeColor: "#73A5C6",
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: "#73A5C6",
              fillOpacity: 0.35,
            }}
          />
        </GoogleMap>
      </div>
    </>
  );
};

export default ReportFence;
